<template>
  <div style="padding-left:8px;">
    <!-- 用户未作答 -->
    <div
      v-if="!submitted"
    >
   <ct-input
      v-model="inputValue"
      width="80%"
      @on-keyup="handleKeyup"
      ref="tiankong"
      @on-focus="focus"
      autocomplete="off"
      placeholder="answer please">
    </ct-input>
      <span class="unit">{{resultUnit}}</span>
    </div>

    <!-- 用户回答正确 -->
    <div
      class="active-right"
      v-if="!!submitted&&!!userAnswer.is_right"
    >
      <ct-input
      width="80%"
        v-model="inputValue"
        class="question-input"
        ref="tiankong"
        @on-keyup="handleKeyup"
        @on-focus="focus"
        autocomplete="off"
        placeholder="answer please">
      </ct-input>
      <ct-icon name="check" class="active-right-icon"></ct-icon>
      <span class="unit">{{resultUnit}}</span>
    </div>
    <!-- 用户回答错误 -->
    <div
      :class="userAnswer.answered ?'active-wrong':''"
      v-if="!!submitted&&!userAnswer.is_right"
    >
      <ct-input
        width="80%"
        ref="tiankong"
        class="question-input"
        v-model="inputValue"
        autocomplete="off"
        @on-keyup="handleKeyup"
        @on-focus="focus"
        placeholder="answer please">
      </ct-input>
      <ct-icon v-show="userAnswer.answered" name="guanbi" class="active-wrong-icon"></ct-icon>
      <span class="unit">{{resultUnit}}</span>
      <div v-show="rightAnswer">正确答案：{{rightAnswer}}</div>
    </div>
  </div>
</template>
<script>
import { mapGetters, mapActions } from 'vuex'

export default {
  name: 'SubQuestionTiankong',
  props: {
    rightAnswer: String,
    userAnswer: {
      type: Object,
      required: true,
      default: () => {
        return {
          answer: 10,
          answered: 1,
          is_right: 1,
          question_id: 72,
          question_index: 1
        }
      }
    },
    resultUnit: {
      type: String
    },
    subId: {
      type: Number,
      required: true
    },
    isFocus: Boolean
  },
  data () {
    return {
      inputValue: ''
    }
  },
  computed: {
    ...mapGetters('answer', ['submitted', 'examSubmitted'])
  },
  watch: {
    userAnswer (userAnswer) {
      this.setInputValue(userAnswer)
    },
    isFocus (value) {
      this.$nextTick(() => {
        if (value) {
          const input = this.$refs.tiankong.$el.querySelector('input')
          input.focus()
          input.selectionEnd = input.value.length
        } else {
          this.$refs.tiankong.$el.querySelector('input').blur()
        }
      })
    }
  },
  methods: {
    ...mapActions('answer', ['updateSubAnswer', 'invalidAnswer', 'submitAnswer']),
    parseValue (value) {
      // eslint-disable-next-line no-useless-escape
      const reg = /[^\d^\.^\e^\+^\-]/g
      let inputValue = value.replace(reg, '')
      return inputValue
    },
    handleKeyup (event) {
      if (document.body.style.overflow === 'hidden') {
        return false
      }
      const value = event.target.value || ''
      const tempValue = this.parseValue(value)
      this.inputValue = tempValue
      if (!this.examSubmitted) {
        this.submitAnswer({
          index: this.subId,
          answer: this.inputValue,
          examId: this.$route.params.exam_id,
          classId: this.$route.params.class_id,
          subclassId: this.$route.params.subclass_id
        })
        this.updateSubAnswer({
          index: this.subId,
          answer: this.inputValue,
          examId: this.$route.params.exam_id,
          classId: this.$route.params.class_id,
          subclassId: this.$route.params.subclass_id
        })
      }

      const number = Number(tempValue)
      const isValid = !isNaN(number)
      if (!isValid) {
        // disable button
        this.invalidAnswer(true)
      } else {
        this.invalidAnswer(false)
      }
    },
    focus () {
      if (!this.isFocus) {
        this.$emit('focus-subquestion', this.subId)
      }
    },
    setInputValue (userAnswer) {
      if (userAnswer) {
        const { answer, answered } = userAnswer
        if (answer !== null && answer !== undefined) {
          if (answered === 0 && answer === 0) {
            this.inputValue = ''
          } else {
            this.inputValue = answer.toString()
          }
        } else {
          this.inputValue = ''
        }
      } else {
        this.inputValue = ''
      }
    }
  },
  mounted () {
    this.setInputValue(this.userAnswer)
    this.$nextTick(() => {
      if (this.$refs.tiankong) {
        if (this.isFocus) {
          this.$refs.tiankong.$el.querySelector('input').focus()
        } else {
          this.$refs.tiankong.$el.querySelector('input').blur()
        }
      }
    })
  }
}
</script>
<style lang="scss" scoped>
@import '@/styles/_varaible.scss';
.unit{
  display: inline-block;
  vertical-align: middle;
  margin-left: 8px;
  height: 48px;
}
.active-wrong{
  .ct-input-contain.question-input{
    border-color: $danger;
  }
  &-icon{
    color: $danger;
    position: absolute;
    margin: 16px 0 16px -24px;
  }
}

.active-right{
  .ct-input-contain.question-input{
    border-color: $success;
  }
  &-icon{
    position: absolute;
    color: $success;
    margin: 16px 0 16px -24px;
  }
}
.ct-input-contain.question-input{
  input::-webkit-outer-spin-button,
  input::-webkit-inner-spin-button {
    -webkit-appearance: none;
  }
  input[type="number"]{
    -moz-appearance: textfield;
  }
  input:focus{
    -moz-appearance: textfield;
    -webkit-appearance: none;
  }
}
</style>
